import {useEffect} from 'react'

const useUnauthorized = () => {
  const eventName = 'unauthorized'

  const redirectToSignIn = () => {
    window.location = '/sign_in'
  }

  useEffect(() => {
    window.addEventListener(eventName, redirectToSignIn)

    return () => {
      window.removeEventListener(eventName, redirectToSignIn)
    }
  }, [])
}

export default useUnauthorized
